import { memo } from 'react';

import { useShortIdContext } from '@air/provider-short-id';

import { SourcesSelect } from '~/components/Selects/SourcesSelect';
import { type BaseStringSelectProps } from '~/components/StringSelect';
import { usePublicSourcesList } from '~/swr-hooks/filters/usePublicSourcesList';

type PublicSourcesSelectProps = {
  boardId: string | undefined;
} & BaseStringSelectProps;

export const PublicSourcesSelect = memo(({ boardId, ...props }: PublicSourcesSelectProps) => {
  const { shortId } = useShortIdContext();

  const { data = [], isLoading } = usePublicSourcesList({
    shortId,
    boardId,
  });

  return <SourcesSelect isLoading={isLoading} sources={data} {...props} />;
});

PublicSourcesSelect.displayName = 'PublicSourcesSelect';
